import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { withTranslation } from "react-i18next";
import { OrganizationKeyName } from "../../model/Organization";
import { RootState } from "../../store";
import Spinner from "../common/Spinner";
import * as authSelectors from "../auth/authSelectors";
import * as emailTemplateSelectors from "./emailTemplateSelectors";
import * as emailTemplateActions from "./emailTemplateActions";
import { EmailTemplateItem } from "../../model/EmailTemplateItem";
import EmailTemplateListRow from "./EmailTemplateListRow";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { Table } from "../../components/table-components/Table";
import { TableRowHeader } from "../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../components/table-components/TableCellHeaderText";
import { ButtonInternalLink } from "../../components/NewButtons";
import { routes } from "../../appRoutingHelpers";

interface OwnProps {}
interface Props {
  getEmailTemplates: (organization: OrganizationKeyName) => void;
  emailTemplates: EmailTemplateItem[];
  organization: OrganizationKeyName | undefined;
  isLoadingEmailTemplates: boolean;
}

interface State {}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
  const organization = authSelectors.selectedOrganizationKeyName(state);

  return {
    organization,
    emailTemplates: emailTemplateSelectors.allEmailTemplates(
      state,
      organization
    ),
    isLoadingEmailTemplates: emailTemplateSelectors.isLoadingEmailTemplates(
      state,
      organization
    ),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getEmailTemplates: (organization: OrganizationKeyName) =>
      dispatch(emailTemplateActions.getEmailTemplatesAction(organization)),
  };
};

class EmailTemplateList extends React.Component<Props, State> {
  componentDidMount() {
    this.props.organization &&
      this.props.getEmailTemplates(this.props.organization);
  }

  render() {
    const organization = this.props.organization;
    if (!organization) {
      return null;
    }

    const t = (this.props as any).t;

    return (
      <div className="container mt-7">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header border-bottom-0 mt-4 mb-4 justify-content-between">
                <StyledText
                  color={colors.textPrimary}
                  className="bodyHeaderOneSemi card-title"
                >
                  Email template List
                </StyledText>
                <ButtonInternalLink to={routes.emailTemplateNew(organization)}>
                  Add new
                </ButtonInternalLink>
              </div>
              <div className="pl-5 pr-5">
                <Table>
                  <thead>
                    <TableRowHeader>
                      <TableCellHeaderText>
                        {t("email_template_list.list.header.name")}
                      </TableCellHeaderText>
                      <TableCellHeaderText>
                        {t("email_template_list.list.header.reply_to_email")}
                      </TableCellHeaderText>
                      <TableCellHeaderText>
                        {t("email_template_list.list.header.reply_to_name")}
                      </TableCellHeaderText>
                      <TableCellHeaderText>
                        {t("email_template_list.list.header.subject")}
                      </TableCellHeaderText>
                      <TableCellHeaderText>
                        {t("email_template_list.list.header.from_address")}
                      </TableCellHeaderText>
                    </TableRowHeader>
                  </thead>
                  <tbody>
                    {this.props.emailTemplates.map((emailTemplate) => (
                      <EmailTemplateListRow
                        organization={organization}
                        key={emailTemplate.id}
                        emailTemplate={emailTemplate}
                      />
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="card-footer text-center mr-5 ml-5 px-0">
                {this.props.isLoadingEmailTemplates && <Spinner />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EmailTemplateList));
